// extracted by mini-css-extract-plugin
module.exports = {"polished_card":"polishedCard_polished_card__8jZ5o"};